import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './components/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import { AuthProvider } from './context/AuthContext';
import JobList from './components/blog/JobList';
import JobAdd from './components/blog/JobAdd';
import JobEdit from './components/blog/JobEdit';
import LandingPageList from './components/landing/LandingPageList';
import LandiingPageAdd from './components/landing/LandiingPageAdd';
import LandingPageEdit from './components/landing/LandingPageEdit';
import IndexNowSubmit from './components/IndexNowPage';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout >
                </Layout>
              </ProtectedRoute>
            }
          >
            <Route path={'/'} element={<JobList />} />
            <Route path={'/index-now'} element={<IndexNowSubmit />} />
            <Route path={'/blog'} element={<JobList />} />
            <Route path={'/blog/add'} element={<JobAdd />} />
            <Route path={'/blog/edit/:jobId'} element={<JobEdit />} />
            <Route path={'/landing'} element={<LandingPageList />} />
            <Route path={'/landing/add'} element={<LandiingPageAdd />} />
            <Route path={'/landing/edit/:jobId'} element={<LandingPageEdit />} />
            <Route path="*" element={<JobList />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;